import { useMemo } from 'react';
import type { Jast } from '@atlaskit/jql-ast';
import { fg } from '@atlassian/jira-feature-gating';
import type { TextSearchInputClauseType } from './types.tsx';
import { TextSearchInputClauseCollectingVisitor } from './text-search-input-clause-collecting-visitor.tsx';

export const useTextSearchInputClause = (
	ast: Jast,
	textSearchInputJqlTerm: string | undefined,
): TextSearchInputClauseType => {
	return useMemo(() => {
		if (!textSearchInputJqlTerm || !fg('shplxi_628_text_search_input_concurrent_fix')) return;
		const visitor = new TextSearchInputClauseCollectingVisitor(textSearchInputJqlTerm);
		return ast.query ? visitor.visit(ast.query) : undefined;
	}, [ast.query, textSearchInputJqlTerm]);
};
